import React from 'react';
import { Plus, Trash2, HelpCircle } from 'lucide-react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Button } from './ui/button';

const FaqEditor = ({ items, onChange, testId = 'faq' }) => {
  const update = (idx, key, value) => onChange(items.map((it, i) => (i === idx ? { ...it, [key]: value } : it)));
  const remove = (idx) => onChange(items.filter((_, i) => i !== idx));
  const add = () => onChange([...items, { question: '', answer: '' }]);

  return (
    <div data-testid={`${testId}-editor`}>
      <div className="flex items-center justify-between mb-2">
        <label className="text-xs font-medium text-gray-600 flex items-center gap-1"><HelpCircle size={13} /> FAQ (3–5 questions, affichées sur la page et envoyées à Google en résultats enrichis) <span className="text-gray-400">({items.length})</span></label>
        <Button type="button" size="sm" variant="outline" data-testid={`${testId}-add`} onClick={add} disabled={items.length >= 10}><Plus size={14} className="mr-1" /> Question</Button>
      </div>
      <div className="space-y-3">
        {items.map((it, idx) => (
          <div key={idx} data-testid={`${testId}-item-${idx}`} className="border border-gray-200 rounded-md p-3 bg-gray-50/60 space-y-2">
            <div className="flex gap-2">
              <Input data-testid={`${testId}-question-${idx}`} value={it.question} onChange={(e) => update(idx, 'question', e.target.value)} placeholder="Question (ex : Quelle est la garantie ?)" className="bg-white" />
              <button type="button" data-testid={`${testId}-remove-${idx}`} onClick={() => remove(idx)} className="p-2 text-red-600 hover:bg-red-50 rounded" title="Supprimer"><Trash2 size={15} /></button>
            </div>
            <Textarea data-testid={`${testId}-answer-${idx}`} value={it.answer} onChange={(e) => update(idx, 'answer', e.target.value.slice(0, 1200))} rows={2} placeholder="Réponse claire et complète (1–3 phrases)" className="bg-white text-sm" />
          </div>
        ))}
        {items.length === 0 && <p className="text-xs text-gray-400 italic">Aucune question. Utilisez « Générer » ou ajoutez-en manuellement.</p>}
      </div>
    </div>
  );
};

export default FaqEditor;
